<script lang="ts">
  import { onMount } from "svelte";
  import { initSubmissionsList, challenge, winning } from "./task-submission.store";
  import { formatTimestampHuman } from "../../utils/date-utils";
  import TaskSubmissionLayout from "./TaskSubmissionLayout.svelte";
  import { ChallengePage } from "./challenge-tab";

  export let sectionId: number;
  export let challengeId: number;

  onMount(() => initSubmissionsList(sectionId, challengeId));
</script>

<TaskSubmissionLayout {sectionId} {challengeId} currentTab={ChallengePage.General}>
  {#if $challenge}
    <div class="content box">
      <h2 class="subtitle" style="margin-bottom:0;">Problem Statement</h2>
      <pre class="statement-text">{$challenge.statement}</pre>
    </div>
  {/if}

  <div class="content box">
    <h2 class="subtitle">Latest Submissions</h2>
    <!--
    <p>Number of people who solved it: 4</p>
    <p>Number of people who tried it: 5</p>
    <p>Number of correct submissions: 4</p>
    <p>Number of solutions submitted: 15</p>
    -->

    <!--
    <table class="submissions-table">
      <tr>
        <td class="user">John Doe</td>
        <td class="score has-text-right is-family-monospace">0.139</td>
      </tr>
      <tr>
        <td class="user">John Doe</td>
        <td class="score has-text-right is-family-monospace">0.139</td>
      </tr>
    </table>
    -->

    <table class="submissions-table">
      <tr>
        <th>Date Time</th>
        <th>User</th>
        <th>Classroom</th>
        <th>Score</th>
      </tr>
      {#if $winning}
        {#each $winning as submission}
          <tr>
            <td>{formatTimestampHuman(submission.createdOn)}</td>
            <td>{submission.userLastName + " " + submission.userFirstName}</td>
            <td>{submission.userClassroom}</td>
            <td>{submission.points}%</td>
          </tr>
        {/each}
        {#if $winning.length == 0}
          <tr>
            <td colspan="4" class="has-text-centered">no completed submissions yet</td>
          </tr>
        {/if}
      {/if}

      <!--
      <tr>
        <td>1234</td>
        <td>2023-04-15 12:33:44</td>
        <td>100 / 100</td>
        <td>Download</td>
      </tr>
      <tr>
        <td>1234</td>
        <td>2023-04-15 12:33:44</td>
        <td>100 / 100</td>
        <td>Download</td>
      </tr>
    -->
    </table>
  </div>
</TaskSubmissionLayout>

<style>
  .statement-text {
    background-color: transparent;
  }

  .submissions-table {
    border: 1px solid #ccc;
  }
</style>
